import axios from "axios";
import urljoin from "url-join";
import { log } from ".";
import { store } from "../store";

function fetchUrl(action, state) {
	const { config } = action.payload;
	let url;

	let extra = {};
	const { type, slug } = action.payload;
	switch (type) {
		case "game":
			url = urljoin(config.routes.api.game, slug);
			break;
		case "section":
			url = urljoin(config.routes.api.sectionBySlug);
			extra = {
				params: {
					sortBy: "page",
					page: 1,
					section: "sectionBySlug",
					section_slug: slug,
					url: `${window.location.origin}/${state.config.section_splitter}/${slug}`,
					mobile: true
				}
			};
			break;
		default:
			break;
	}
	if (typeof state.urlprefetch.cache[url] !== "undefined") {
		return;
	}
	axios
		.get(url, extra)
		.then(response => {
			let toRequest = url;
			if (typeof extra.params !== "undefined") {
				toRequest = urljoin(
					url,
					`?${Object.entries(extra.params)
						.map(([key, val]) => `${key}=${val}`)
						.join("&")}`
				);
			}

			store.dispatch({
				type: "SAVE_ROUTE",
				payload: {
					data: response,
					url: toRequest
				}
			});
		})
		.catch(error => console.log({ type }, { url }, { error }));
}

function getUrl(url, extra = {}) {
	return new Promise((resolve, reject) => {
		let toRequest = url;
		if (Object.keys(extra).length !== 0) {
			toRequest = urljoin(
				url,
				`?${Object.entries(extra.params)
					.map(([key, val]) => `${key}=${val}`)
					.join("&")}`
			);
		}

		const state = store.getState();
		if (typeof state.urlprefetch.cache[toRequest] !== "undefined") {
			log(__filename, `Sirviendo ${toRequest} desde cache`);
			resolve(state.urlprefetch.cache[toRequest]);
		} else {
			log(__filename, `Debemos pedir ${toRequest}`);
			axios
				.get(url, extra)
				.then(response => {
					store.dispatch({
						type: "SAVE_ROUTE",
						payload: {
							data: response,
							url: toRequest
						}
					});
					resolve(response);
				})
				.catch(error => reject(error));
		}
	});
}

function handleProcessing(deadline) {
	if (typeof deadline !== "undefined") {
		let interval = setInterval(() => {
			const state = store.getState();
			const { queue } = state.urlprefetch;
			if (queue.length > 0) {
				const el = queue.shift();
				fetchUrl(el, state);
				store.dispatch({
					type: "SHIFT_QUEUE",
					payload: {}
				});
			}
			if (deadline.timeRemaining() <= 0) {
				clearInterval(interval);
				startProcessing();
			}
		}, 200);
	} else {
		const state = store.getState();
		const { queue } = state.urlprefetch;
		if (queue.length > 0) {
			const el = queue.shift();
			fetchUrl(el, state);
			store.dispatch({
				type: "SHIFT_QUEUE",
				payload: {}
			});
		}
	}
}

function startProcessing() {
	if ("requestIdleCallback" in window) {
		window.requestIdleCallback(handleProcessing);
	} else {
		setInterval(() => {
			handleProcessing();
		}, 200);
	}
}

export default {
	fetchUrl,
	getUrl,
	startProcessing
};
